module.exports = __webpack_public_path__ + "img/plstudent-qrcode.526842be.png";